import { render, staticRenderFns } from "./WellnessDistributionChart.vue?vue&type=template&id=1ad871d2&scoped=true"
import script from "./WellnessDistributionChart.vue?vue&type=script&lang=js"
export * from "./WellnessDistributionChart.vue?vue&type=script&lang=js"
import style0 from "./WellnessDistributionChart.vue?vue&type=style&index=0&id=1ad871d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad871d2",
  null
  
)

export default component.exports